module.exports = __webpack_public_path__ + "img/part3.prt.78f0836c.jpg";